'use client';

import { useState } from 'react';

import {
    Button,
    ButtonList,
    ButtonVariant,
    ModalBody,
    ModalFooter,
    RadioTile,
    RadioTiles,
    Text,
    TextLevels,
    TypographyAlign,
} from '@bytel/trilogy-react';

import { PLAY } from '@constants/provider';

import { FaiUpsellModalProps } from './fai-upsell-modal.props';

export function ByouUpsellModal({ clickedOffer, upsellOffer, onAddOffer }: Readonly<FaiUpsellModalProps>) {
    const [choice, setChoice] = useState<PLAY>(PLAY._3P);

    return (
        <>
            <ModalBody>
                <RadioTiles>
                    <RadioTile
                        name='checkbox1'
                        id='choiceYes'
                        label='Oui, je garde le décodeur (+0€)'
                        description='Box TV 4K + 180 chaînes'
                        value={PLAY._3P}
                        checked={choice === PLAY._3P}
                        onChange={() => setChoice(PLAY._3P)}
                        horizontal
                    />
                    <RadioTile
                        name='checkbox1'
                        id='choiceNo'
                        label='Non, pas besoin'
                        description='-5€ offerts les 3 premiers mois*'
                        value={PLAY._2P}
                        checked={choice === PLAY._2P}
                        onChange={() => setChoice(PLAY._2P)}
                        horizontal
                    />
                </RadioTiles>
                <Text level={TextLevels.THREE} typo={TypographyAlign.TEXT_LEFT}>
                    *soit un total de 15€ de réductions, déduits sur les 3 premières factures.
                </Text>
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button
                        variant={ButtonVariant.CONVERSION}
                        onClick={() => onAddOffer?.(choice === PLAY._3P ? clickedOffer : upsellOffer)}
                    >
                        Continuer
                    </Button>
                </ButtonList>
            </ModalFooter>
        </>
    );
}
